import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { fr } from 'date-fns/locale';

const RentmanCalendar = (
    {
        startDate,
        onChange,
    }
) => {
    registerLocale('fr', fr);
    return (
      <div className='RentmanCalendar'>
        <DatePicker
          selected={startDate}
          onChange={(date) => onChange(date)}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
          locale="fr"
          dateFormat="dd/MM/yyyy" 
        />
      </div>
    );
}

export default RentmanCalendar;